
export const MEDIA_QUERIES = {
    xs: '(max-width: 699px)',
    gt_xs: '(min-width: 700px)',
    sm: '(max-width: 959px) and (min-width: 700px)',
    gt_sm: '(min-width: 960px)',
    md: '(max-width: 1279px) and (min-width: 960px)',
    gt_md: '(min-width: 1280px)',
    lg: '(max-width: 1919px) and (min-width: 1280px)',
    gt_lg: '(min-width: 1920px)',
    xl: '(min-width: 1920px)'
};

export const GRID_MODES = {
    LIST: 'list',
    GRID: 'grid'
};

export const BACKGROUNDS = {
    MIDNIGHT_BLUE: 'midnight',
    TEQUILA_SUNRISE: 'tequila',
    ROBINS_EGG_BLUE: 'robins',
    EGGPLANT_PURPLE: 'eggplant',
    OCEAN_FLOOR: 'ocean',
    WHITE: 'white',
    GREY: 'grey'
};

export const FILE_TYPES = {
    DR: '2D Drawing',
    M2: '2D Model',
    M3: '3D Model',
    BQ: 'Bill of Quantities',
    CP: 'Cost Plan',
    IE: 'Information Exchange',
    HS: 'Health & Safety',
    SP: 'Specification',
    SH: 'Schedule',
    CA: 'Calculations',
};

export const VOLUMES = {
    V1: 'Volume one',
    V2: 'Volume two',
    V3: 'Volume three',
    V4: 'Volume four',
};

export const LEVELS = {
    ZZ: 'Multiple levels',
    XX: 'No level',
    GF: 'Ground floor',
    '00': 'Base level',
    '01': 'Level one',
    '02': 'Level two',
    M1: 'Mezzanine one',
    M2: 'Mezzanine two',
    B1: 'Basement one',
    B2: 'Basement two',
};

export const LEVELS_OF = [1, 2, 3, 4, 5, 6];

export const CONTAINER_STATUSES = {
    PLACEHOLDER: 'placeholder',
    WIP: 'wip',
    SHARED: 'shared'
};

export const AREA_ORG_JOINS = {
    SUPPLIER: 'SUPPLIER',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
    REGULATORY: 'REGULATORY',
};

export const AREA_ORG_JOINS_LIST = Object.keys(AREA_ORG_JOINS).map(k => AREA_ORG_JOINS[k]);

export const AREA_PERS_JOINS = {
    MEMBER: 'MEMBER',
    LEAD: 'LEAD',
    SPECIALIST: 'SPECIALIST',
    MANAGER: 'MANAGER',
    DIRECTOR: 'DIRECTOR',
};

export const AREA_PERS_JOINS_LIST = Object.keys(AREA_PERS_JOINS).map(k => AREA_PERS_JOINS[k]);

/**
 * Table column type definitions
 */
export const TABLE_COLUMN_TYPES = {
    STRING: 'string',
    DATE: 'date',
    ID: 'identifier',
    ACTION: 'action',
    ACTION_COUNT: 'action_count'
};
export const TABLE_COLUMN_WIDTHS = {
    [TABLE_COLUMN_TYPES.ID]: 230,
    [TABLE_COLUMN_TYPES.ACTION]: 52,
    [TABLE_COLUMN_TYPES.ACTION_COUNT]: 90
};

/**
 * Document revision statuses
 */
export const DOCUMENT_REV_STATUSES = {
    WIP: 'WIP',
    PUBLIC: 'PUBLIC',
    ARCHIVED: 'ARCHIVED'
};

export const DOCUMENT_CDE_VIEWS = {
    WIP: 'WIP',
    SHARED: 'SHARED',
    PUBLIC: 'PUBLIC',
    ARCHIVED: 'ARCHIVED',
};
